export const getValidation = state => state.validationContent.data;
export const getError = state => state.validationContent.error;
export const getPaymentData = state => state.validationContent.paymentData;
export const getPaypalData = state => state.validationContent.paypalData;
